/** @module csi/skintheme/ArcticFresh */
define([], function() {
	return {
		Blue1: "Blue30",
		Blue2: "Blue50",
		Blue3: "Blue500",

		PrimaryBlue: "Blue600",
		PrimaryDisabledColor: "Blue200",
		PrimaryColor2: "Blue700",
		PrimaryColor3: "Blue900",

		SiteHeaderBackground: "Grey50",

		CompanyHeaderBlue1: "Grey50",
		CompanyHeaderBlue2: "Grey200",

		/* LINK */
		LinkNormal: "Blue600",
		LinkHover: "Blue800",
		LinkActive: "Blue600",

		/* Comment */
		CommentActiveColor: "Blue600",

		/** custom view */
		CustomViewOptionActiveColor: "Blue500",

		/* FULL SCREEN HEADER */
		FullScreenHeaderBackgroundColor: "Grey50",
		FullScreenLogoBackgroundColor: "Grey50",

		/* TEXT */
		TabsTextActive: "Blue600",

		/* Button */
		BtnPrimaryFocusedBorderColor: "Blue900",
		ButtonSwitchNormalIconStateOnBackgroundColor: "Blue600",

		/* BreadCrumb */
		BreadcrumbNormalLinkColor: "Blue600",

		/* CheckBox */
		CheckBoxFocusColor: "Blue300",

		/* Text Border */
		TextfieldActiveBorderColor: "PrimaryColor",
		BtnToolbarFocusedBorderColor: "PrimaryColor",

		/* DropDown */
		DropdownSelectActiveBorderColor: "PrimaryColor",

		/* Header */
		LastVisitedIconColor: "Grey50",
		LastVisitedBackgroundColor: "Black400",
		PageHeaderButtonTextColor: "SecondaryText",
		PageHeaderToolbarIconColor: "Black400",
		PageHeaderToolbarHoverColor: "Blue600",
		PageHeaderSearchInButtonHoverColor: "Grey100",
		PageHeaderToolbarSeparatorColor: "Grey300",
		PageHeaderSearchScopeBackgroundColor: "White50",
		PageHeaderSearchBlockBackgroundColor: "Grey300",
		CompanyLogoTextColor: "Black50",
		CompanyLogoImageURL: "LightCompanyLogoIconURL",
		ExitFullScreenIconURL: "LightExitFullScreenIconURL",

		/* Table */
		TableCopyBorderColor: "Blue600",
		TablePasteBorderColor: "Blue600",
		TableNewRowBackgroundColor: "Blue100",

		/* Slicer */
		SlicerMetricsBackgroundColor: "Blue100",

		/* Chart */
		ChartAreaURL: "ChartAreaBlueURL",
		ChartBarURL: "ChartBarBlueURL",
		ChartColumnURL: "ChartColumnBlueURL",
		ChartDoughnutURL: "ChartDoughnutBlueURL",
		ChartLineURL: "ChartLineBlueURL",
		ChartMsAreaURL: "ChartMsAreaBlueURL",
		ChartMsBarURL: "ChartMsBarBlueURL",
		ChartMsColumnURL: "ChartMsColumnBlueURL",
		ChartMsLineURL: "ChartMsLineBlueURL",
		ChartParetoURL: "ChartParetoBlueURL",
		ChartPieURL: "ChartPieBlueURL",
		ChartStackedAreaURL: "ChartStackedAreaBlueURL",
		ChartStackedBarURL: "ChartStackedBarBlueURL",
		ChartStackedColumnURL: "ChartStackedColumnBlueURL",

		/* Progress bar */
		ProgressBarDeterminateProgressColor: "PrimaryColor",

		HighlightSelected: "Grey200"
	};
});